<!--
 * @Author: wh
 * @Date: 2020-07-09 11:54:56
 * @LastEditTime: 2022-10-20 17:19:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\overApplication\overContractList.vue
-->
<template>
    <div class="commonTableStyles overContractList">
        <van-nav-bar
            title="选择合同"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <van-search v-model="keywords" placeholder="请输入合同名称或编号" @change="search"></van-search>
        <div class="project-list">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                v-if="total"
            >
                <ul class="list">
                    <template v-for="item in contractList">
                        <li :key="item.cvid" @click="chosedContract(item)">
                            <div class="engineeringInfo">
                                <h4 class="engineeringInfo_header">
                                    <span class="headerName">合同编号：{{ item.contract_number }}</span>
                                </h4>
                                <div class="engineeringInfo_content">
                                    <p>
                                        <span class="info">工程名称：{{ item.engineering_name }}</span>
                                    </p>
                                    <p>
                                        <span class="info">签订日期：{{ item.signing_date }}</span>
                                    </p>
                                    <p>
                                        <span class="info">客户名称：{{ item.client_name }}</span>
                                    </p>
                                </div>
                            </div>
                        </li>
                    </template>
                </ul>
            </van-list>
            <div class="no-data" v-else></div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            MobilePhone: '',
            pagetion: {
                pageindex: 0,
                pageSize: 5,
            },
            contractList: [],
            formData: {},
            loading: false,
            finished: false,
            total: true,
            keywords: '',
            parentPageName: '',
        };
    },
    watch: {},
    computed: {},
    created() {
        this.parentPageName = this.$route.params.pageName;
        this.formData = this.$route.params.formData;
    },
    mounted() {
    },
    methods: {
        // 返回
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 搜索
        search() {
            this.pagetion.pageindex = 0;
            this.contractList = [];
            this.onLoad();
        },
        // 数据分页加载
        onLoad() {
            this.pagetion.pageindex++;
            this.$axios
                .get('/interfaceApi/sale/contract_manager/get_page_audit?keywords=' + this.keywords + '&pageindex='
                + this.pagetion.pageindex + '&pageSize=' + this.pagetion.pageSize)
                .then(res => {
                    this.loading = false;
                    if (res.total) {
                        this.total = true;
                        this.contractList = this.contractList.concat(res.rows);
                        if (this.contractList.length >= res.total) {
                            this.finished = true;
                        }
                    } else {
                        this.total = false;
                        this.finished = true;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 通过code拉取字典信息
        getbycode(num) {
            return this.$axios.get('/interfaceApi/baseinfo/dictionary_config/getbycode/' + num);
        },
        // 选中合同
        chosedContract(data) {
            this.formData.contract_number = data.contract_number;
            this.formData.contract_type_name = data.contract_type_name;
            this.formData.engineering_name = data.engineering_name;
            this.formData.engineering_location = data.engineering_location;
            this.formData.client_name = data.client_name;
            this.formData.client_uscc = data.client_uscc;
            this.formData.contract_version_id = data.cvid;
            this.$router.isBack = 1;
            this.$router.replace({
                name: this.parentPageName,
                params: {
                    formData: this.formData,
                    actionType: 'selectedProjectCallBack',
                },
            });
            this.$router.go(-1);
        },
    },

};
</script>
<style lang="stylus">
.overContractList
    height calc(100% - 44rpx)
    .project-list
        height 100%
        overflow-y auto
        overflow-x hidden
        background #F0F0F0
        .van-list
            padding-bottom 60rpx
</style>
